import type { ReactNode } from 'react';
import { Container, GuideArea, GuideHint, GuideTitle } from './style';

const ContentContainer = ({ children }: { children: ReactNode }) => {
  return (
    <Container>
      <GuideArea>
        <GuideTitle>면접환경 체크</GuideTitle>
        <GuideHint>
          면접환경 체크 중 문제가 발생할 경우 상단 우측 문제 해결 가이드를
          참고하세요.
        </GuideHint>
      </GuideArea>
      {children}
    </Container>
  );
};

export default ContentContainer;
